import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";
import { AppErrorBoundary } from "@/components/app-error-boundary";

const SessionPage = lazy(async () => {
  const m = await import("@/features/gym/components/session-page");
  return { default: m.SessionPage };
});

function SessionRoutePage() {
  const params = useParams({ from: "/_app/session/$sessionId" });
  return (
    <AppErrorBoundary label="session">
      <Suspense fallback={null}>
        <SessionPage sessionId={() => params().sessionId} />
      </Suspense>
    </AppErrorBoundary>
  );
}

interface SessionSearch {
  /** Exercise picker open (`?picker=1`) or custom exercise creation (`?picker=new`). */
  picker?: "1" | "new";
  /** Carousel position in active session (`?ex=<index 1-based>`). */
  ex?: number;
}

export const sessionRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/session/$sessionId",
  validateSearch: (search: Record<string, unknown>): SessionSearch => {
    // CC-18: also accepts the NUMBER 1 (TanStack JSON-parses `?picker=1` to number 1).
    const picker =
      search.picker === "1" || search.picker === 1
        ? ("1" as const)
        : search.picker === "new"
          ? ("new" as const)
          : undefined;
    const exRaw = Number(search.ex);
    const ex = Number.isInteger(exRaw) && exRaw >= 1 ? exRaw : undefined;
    // Omit empty values for clean and idempotent URLs.
    return {
      ...(picker ? { picker } : {}),
      ...(ex ? { ex } : {}),
    };
  },
  component: SessionRoutePage,
});
